import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const classicProjectSettingsServiceDeskFieldsRoute: InvariantJiraRoute = {
	name: 'classic-project-settings-servicedesk-fields',
	path: '/jira/servicedesk/c/projects/:projectKey/settings/fields',
	exact: true,
};
